module.exports = __webpack_public_path__ + "static/media/certificate.326c1248.svg";